import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const lawsData = [
  {
    title: "Loi N° 1/18 du 24 juillet 2023 portant la modification de la Loi N° 1/08 du 20 mai 2021 sur la modification de la Loi N° 1/17 du 25 septembre 2007 relative à l'organisation du système statistique national au Burundi",
    principalLink: "/documents/laws/Loi-N°-1-18-du-24-juillet-2023-portant-organisation-du-SSN-du-Burundi.pdf",
    image: 'assets/laws/protection_donnees.PNG', 
    description: "Actualisation du cadre légal du système statistique national pour renforcer la qualité et la transparence des données officielles.",
    date: "2023-07-24",
    publicationDate: "2023-07-24"
  },
  {
    title: "Charte africaine de la statistique",
    principalLink: "/documents/laws/charte-africaine-de-la-statistique-2.pdf",
    image: 'assets/laws/transparence.PNG',
    description: "Cadre normatif continental pour harmoniser les pratiques statistiques en Afrique selon les standards internationaux.",
    date: "2009-05-08",
    publicationDate: "2009-05-08"
  },
  {
    title: "Constitution de la République du Burundi",
    principalLink: "/documents/laws/Constitution-de-la-République-du-Burundi.pdf",
    image: 'assets/laws/transparence.PNG',
    description: "Texte fondamental encadrant l'ensemble des activités institutionnelles, y compris la production statistique.",
    date: "2018-06-20",
    publicationDate: "2018-07-01"
  },
  {
    title: "Loi N° 1/08 du 20 mai 2021 portant modification de la Loi N° 1/17 du 25 septembre 2007 sur l'organisation du système statistique national au Burundi",
    principalLink: "/documents/laws/LOI-N°1.08-DU-20-MAI-2021-PORTANT-MODIFICATION-DE-LA-LOI-N°1.17-DU-25-SEPTEMBRE-2007-PORTANT-ORGANISATION-DU-SYSTEME-STATISTIQUE-AU-BURUNDI.pdf",
    image: 'assets/laws/transparence.PNG',
    description: "Réforme du système statistique national pour améliorer sa coordination et son efficacité opérationnelle.",
    date: "2020-06-20",
    publicationDate: "2020-07-01"
  },
  {
    title: "Loi N° 1/05 du 22 avril 2009 portant révision du Code pénal",
    principalLink: "/documents/laws/Loi-N°1-du-22-avril-2009-portant-révision-du-code-pénal.doc",
    image: 'assets/laws/transparence.PNG',
    description: "Dispositions pénales relatives à la protection des données et au secret statistique.",
    date: "2009-04-22",
    publicationDate: "2009-04-22"
  },
  {
    title: "Le cadre légal de la statistique au Burundi",
    principalLink: "/documents/laws/loi-statistique-du-burundi-1.pdf",
    image: 'assets/laws/transparence.PNG',
    description: "Ensemble des textes régissant la production et la diffusion des statistiques officielles au Burundi.",
    date: "2020-06-20",
    publicationDate: "2020-07-01"
  },
];


function LegalFramework() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredLaws, setFilteredLaws] = useState(lawsData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    let filtered;

    if (year === 'Tous') {
      filtered = lawsData;
    } else {
      filtered = lawsData.filter((law) => {
        const lawYear = new Date(law.date).getFullYear();
        return lawYear === parseInt(year);
      });
    }

 
    filtered.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));
    setFilteredLaws(filtered);
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Légistration 
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
           L'ensemble des lois en vigueur concernant le système statistique national (SSN). Vous y trouverez des textes législatifs, des réglementations, ainsi que des ressources précieuses pour comprendre le cadre juridique qui régit la collecte, l'analyse et la diffusion des données statistiques au niveau national.
          </Typography>
          <FormControl fullWidth variant="outlined"  style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année d'adoption</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année d'adoption"
            >
              <MenuItem value="Tous">Toutes les lois</MenuItem>
              {[...new Set(lawsData.map((law) => new Date(law.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredLaws.slice(0, visibleCount).map((law, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={law.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={law.image}
                        alt={law.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={law.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                         {<DownloadIcon />} {law.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {law.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié le {moment(law.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredLaws.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Lois
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default LegalFramework;